module.exports = __webpack_public_path__ + "img/toggler-icon.ae1356dd.svg";